export enum ReportMode {
  iopRequest = 'iop_request',
  periodic = 'periodic',
  single = 'single',
}
